var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCounterclockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0022 7c2.7615 0 5 2.2386 5 5s-2.2385 5-5 5a4.989 4.989 0 0 1-1.7936-.3313l-1.5063 1.5062c.9832.5265 2.1067.8251 3.2999.8251 3.866 0 7-3.134 7-7s-3.134-7-7-7c-3.8403 0-6.9584 3.0926-6.9995 6.9233L3.417 10.3377 2.003 11.752l4.2427 4.2426 4.2426-4.2426-1.4142-1.4143-2.0713 2.0713v-.478C7.0397 9.2014 9.264 7 12.0022 7z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCounterclockwise);
export default __webpack_public_path__ + "static/media/arrow-counterclockwise.0147175167fe4b61efd1e915182e65c2.svg";
export { ForwardRef as ReactComponent };